import React from 'react';
import { Rows, hasRows, num, pct, pretty } from '../StatRows';
import SplitBar from '../charts/SplitBar';

/* "Campus" accordion. Mirrors `campusBody` in MatchDetailSheet.swift.

   `pct_women` is deliberately NOT a row: the SplitBar below carries it plus
   the men's complement, so a row would state the same number twice. HBCU and
   Tribal have no iOS/Android equivalent but the payload carries them and web
   has always shown them, so they stay — both only when true, since "HBCU: No"
   is noise on the thousands of schools that aren't one. */

function build(detail) {
  const c = detail.campus || {};
  return {
    women: c.pct_women,
    rows: [
      { label: 'Total enrollment', value: num(c.enrollment_total) },
      { label: 'Undergrad enrollment', value: num(c.enrollment_ug) },
      { label: 'Size', value: pretty(c.size_bucket) },
      { label: 'Setting', value: pretty(c.setting) },
      { label: 'Public / Private', value: pretty(c.control) },
      { label: '% international', value: pct(c.pct_international) },
      { label: '% Black', value: pct(c.pct_black) },
      { label: '% Hispanic', value: pct(c.pct_hispanic) },
      { label: '% Asian', value: pct(c.pct_asian) },
      { label: 'HBCU', value: c.hbcu ? 'Yes' : null },
      { label: 'Tribal college', value: c.tribal ? 'Yes' : null },
    ],
  };
}

export function hasContent(detail) {
  const b = build(detail);
  return hasRows(b.rows) || b.women != null;
}

export default function CampusSection({ detail }) {
  const { rows, women } = build(detail);
  const men = women != null ? 100 - women : null;

  return (
    <>
      <Rows rows={rows} />
      <SplitBar
        caption="Student body — women / men"
        leftLabel="Women" rightLabel="Men"
        left={women} right={men}
        leftTone="gold" rightTone="blue"
      />
    </>
  );
}
